export function employeeInputValue(name, value, previous = "") {
  if (name === "phone") return value.replace(/\D/g, "").slice(0, 10);
  if (name === "aadhaarNumber") return value.replace(/\D/g, "").slice(0, 12);
  if (name === "panNumber") {
    const next = value.toUpperCase().slice(0, 10);
    return /^(?:[A-Z]{0,5}|[A-Z]{5}\d{0,4}|[A-Z]{5}\d{4}[A-Z])$/.test(next)
      ? next
      : previous;
  }
  if (
    ["dob", "dateOfBirth", "joiningDate"].includes(name) &&
    /^\d{5,}-/.test(value)
  )
    return previous;
  return value;
}
export function validEmployeeDate(value) {
  if (!/^(?!0000)\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(value + "T00:00:00Z");
  return (
    Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
  );
}
export function employeeInputError(form) {
  if (form.phone && !/^\d{10}$/.test(form.phone))
    return "Mobile number must contain exactly 10 digits.";
  if (form.dob && !validEmployeeDate(form.dob))
    return "Date of birth must be a valid date with a four-digit year.";
  if (form.joiningDate && !validEmployeeDate(form.joiningDate))
    return "Joining date must be a valid date with a four-digit year.";
  if (form.aadhaarNumber && !/^\d{12}$/.test(form.aadhaarNumber))
    return "Aadhaar number must contain exactly 12 digits.";
  if (form.panNumber && !/^[A-Z]{5}\d{4}[A-Z]$/.test(form.panNumber))
    return "PAN must contain five letters, four digits and one final letter (ABCDE1234F).";
  return "";
}
